import styled from 'styled-components';

export const SignInBlock = styled.div`
  display: flex;
  flex-direction: column;
  width: 380px;

  h2 {
    margin: 10px 0px;
  }
`;

export const ButtonsBlock = styled.div`
  display: flex;
  justify-content: space-between;
`;
